import { handleize } from 'helpers/utils'

const selectors = {
  NO_BRAND: 'no-brand'
}

function ProductCardVendor({ vendor }) {
  const handle = handleize(vendor)

  if (handle === selectors.NO_BRAND) {
    return <div className="mt-1 h-[18px] bg-transparent p-[3px] md:mt-2 md:h-6 lg:mt-3"></div>
  }

  const brand = GM_STATE.brands.find((item) => item.vendor === handle)

  return (
    <div className="mt-1 md:mt-2 lg:mt-3">
      {brand ? (
        <a
          href={brand?.url}
          className="flex size-fit h-[18px] items-center justify-center rounded-sm border border-grey-200 bg-grey-100 p-[3px] transition duration-300 hover:bg-white md:h-6 md:px-[5px]"
          title={vendor}
        >
          <img
            src={brand.src}
            width={brand.width}
            height={brand.height}
            alt={vendor}
            className="h-2.5 w-auto object-contain md:h-[15px]"
          />
        </a>
      ) : (
        <div className="flex size-fit h-[18px] items-center justify-center rounded-sm border border-grey-200 bg-grey-100 p-[3px] transition duration-300 hover:bg-white md:h-6 md:px-[5px]">
          <p className="font-semibold leading-none tracking-tight text-grey-900" style={{ fontSize: '10px' }}>
            {vendor}
          </p>
        </div>
      )}
    </div>
  )
}

export default ProductCardVendor
